import { render } from "./MainHeading.vue?vue&type=template&id=e063fab4&scoped=true"
import script from "./MainHeading.vue?vue&type=script&lang=js"
export * from "./MainHeading.vue?vue&type=script&lang=js"

import "./MainHeading.vue?vue&type=style&index=0&id=e063fab4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e063fab4"]])

export default __exports__